import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { STATES } from "../../../components/oems/helper";

export const HeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Dealer Name",
    id: "dealerName",
  },
  {
    label: "Dealer Location",
    id: "dealerLocation",
  },
  {
    label: "Shipping Point",
    id: "shippingPoint",
  },
  {
    label: "Equipment Model",
    id: "equipmentModel",
  },
  {
    label: "Profit Center",
    id: "profitCenter",
  },
  {
    label: "Application",
    id: "application",
  },
  {
    label: "Claim Number",
    id: "claimNumber",
  },
  {
    label: "State",
    id: "state",
  },
  {
    label: "Status",
    id: "status",
  },
  {
    label: "Part Value",
    id: "partValue",
  },
  { label: "Claim Reference Number", id: "claimReferenceNumber" },
  {
    label: "Date of Claim Submission",
    id: "claimSubmissionDate",
    render: (data) => {
      return (
        <span>
          {data?.claimSubmissionDate &&
            moment(data.claimSubmissionDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Engine Serial Number",
    id: "engineSerialNumber",
  },
  { label: "Machine Serial Number", id: "machineSerialNumber" },
  {
    label: "Date of Machine Sale",
    id: "machineSaleDate",
    render: (data) => {
      return (
        <span>
          {data?.machineSaleDate &&
            moment(data.machineSaleDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Date of Failure",
    id: "dateOfFailure",
    render: (data) => {
      return (
        <span>
          {data?.dateOfFailure &&
            moment(data.dateOfFailure).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Receipt Date",
    id: "receiptDate",
    render: (data) => {
      return (
        <span>
          {data?.receiptDate && moment(data.receiptDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Hours Covered",
    id: "hoursCovered",
  },
  {
    label: "Customer Complaint",
    id: "customerComplaint",
  },
  {
    label: "Defect Description",
    id: "defectDescription",
  },
  {
    label: "Simpson Part Number",
    id: "simpsonPartNumber",
  },
  {
    label: "Part Number Description",
    id: "partDescription",
  },
  {
    label: "Reason",
    id: "reason",
  },
  {
    label: "Action Taken",
    id: "actionTaken",
  },
  {
    label: "Qty",
    id: "qty",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton>
          <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
        </IconButton>
      </Box>
    ),
  },
];
export const getClaimFormConfig = (
  complaintCodes = [],
  defectCodeList = []
) => [
  {
    name: "dealerName",
    type: "text",
    label: "Dealer Name",
    placeholder: "Enter Dealer Name",
    required: true,
  },
  {
    name: "dealerLocation",
    type: "text",
    label: "Dealer Location",
    placeholder: "Enter Dealer Location",
    required: true,
  },
  {
    name: "claimReferenceNumber",
    type: "text",
    label: "Claim Reference Number",
    placeholder: "Claim Reference NUmber",
    required: true,
  },
  {
    name: "claimSubmissionDate",
    type: "datePicker",
    label: "Claim Submission Date",
    placeholder: "Claim Submission Date",
    required: true,
  },
  {
    name: "engineSerialNumber",
    type: "text",
    label: "Engine Serial Number",
    placeholder: "Engine Serial Number",
    required: true,
  },
  {
    name: "shippingPoint",
    type: "text",
    label: "Shipping Point",
    placeholder: "Shipping Point",
    required: true,
  },
  {
    name: "profitCenter",
    type: "text",
    label: "Profit Center",
    placeholder: "Profit Center",
    required: true,
  },
  {
    name: "status",
    type: "text",
    label: "Status",
    placeholder: "Status",
    required: true,
  },
  {
    name: "partValue",
    type: "text",
    label: "Part Value",
    placeholder: "Part Value",
    required: true,
  },
  {
    name: "partDescription",
    type: "text",
    label: "Part Description",
    placeholder: "Part Description",
    required: true,
  },
  {
    name: "application",
    type: "text",
    label: "Application",
    placeholder: "Application",
    required: true,
  },
  {
    name: "equipmentModel",
    type: "text",
    label: "Equipment Model",
    placeholder: "Equipment Model",
    required: true,
  },
  {
    name: "claimNumber",
    type: "text",
    label: "Claim Number",
    placeholder: "Claim Number",
    required: true,
  },
  {
    name: "state",
    type: "autocomplete",
    options: STATES,
    label: "State",
    placeholder: "Select State",
    required: true,
  },
  {
    name: "machineSerialNumber",
    type: "text",
    label: "Machine Serial Number",
    placeholder: "Machine Serial Number",
    required: true,
  },
  {
    name: "machineSaleDate",
    type: "datePicker",
    label: "Machine Sale Date",
    placeholder: "Machine Sale Date",
    required: true,
  },
  {
    name: "dateOfFailure",
    type: "datePicker",
    label: "Date of Failure",
    placeholder: "Date of Failure",
    required: true,
  },
  {
    name: "receiptDate",
    type: "datePicker",
    label: "Receipt Date",
    placeholder: "Receipt Date",
    required: true,
  },
  {
    name: "hoursCovered",
    type: "number",
    label: "Hours Covered",
    placeholder: "Hours Covered",
    required: true,
  },

  {
    name: "customerComplaint",
    type: "autocomplete",
    options: complaintCodes,
    label: "Nature Of Complaint",
    placeholder: "Nature Of Complaint",
    required: true,
  },
  {
    name: "defectDescription",
    type: "autocomplete",
    options: defectCodeList,
    label: "Defect Description",
    placeholder: "Select Defect",
    required: true,
  },
  {
    name: "simpsonPartNumber",
    type: "text",
    label: "Simpson Part Number",
    placeholder: "Part Number",
    required: true,
  },
  {
    name: "qty",
    type: "text",
    label: "Quantity",
    placeholder: "Quantity",
    required: true,
  },

  {
    name: "reason",
    type: "textarea",
    label: "Reason",
    placeholder: "Reason",
    required: true,
    fieldGridSize: 6,
  },
  {
    name: "actionTaken",
    type: "textarea",
    label: "Action Taken",
    placeholder: "Action Taken",
    required: true,
    fieldGridSize: 6,
  },
];
